// src/router/index.js
import Vue from 'vue';
import VueRouter from 'vue-router';
import HomeView from '../views/HomeView.vue';
import AboutView from '../views/AboutView.vue';
import ServicesView from '../views/ServicesView.vue';
import ContactView from '../views/ContactView.vue';

// 作品分类页面
import UiDesignView from '../views/works/UiDesignView.vue';
import WebDevView from '../views/works/WebDevView.vue';
import MobileAppView from '../views/works/MobileAppView.vue';
import BrandingView from '../views/works/BrandingView.vue';
import DataVizView from '../views/works/DataVizView.vue';


Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { title: '首页 | 优毕学社' }
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView,
    meta: { title: '关于我们' }
  },
  {
    path: '/services',
    name: 'services',
    component: ServicesView,
    meta: { title: '资源获取' }
  },
  {
    path: '/works/ui-design',
    name: 'ui-design',
    component: UiDesignView,
    meta: { title: '汉语言文学' }
  },
  {
    path: '/works/web-dev',
    name: 'web-dev',
    component: WebDevView,
    meta: { title: '网页开发作品' }
  },
  {
    path: '/works/mobile-app',
    name: 'mobile-app',
    component: MobileAppView,
    meta: { title: '移动应用作品' }
  },
  {
    path: '/works/branding',
    name: 'branding',
    component: BrandingView,
    meta: { title: '品牌设计作品' }
  },
  {
    path: '/works/data-viz',
    name: 'data-viz',
    component: DataVizView,
    meta: { title: '计算机作品' }
  },
  {
    path: '/contact',
    name: 'contact',
    component: ContactView,
    meta: { title: '联系方式' }
  },
  {
    path: '*',
    redirect: '/'
  }
];



const router = new VueRouter({
  mode: 'hash',
  // mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

export default router;